<template>
  <layout-variant-two :show-loading-screen="loading" hideFootNote>
    <template v-slot:header>
      <div class="slide-down" v-if="!inModal">
        <div class="header-con float" @click="goTo('HomePage')">
          <div class="material-icons">arrow_back</div>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <landing-layout :is-loading="!inited" :in-modal="inModal" :hide-banner="proceedOTP">
        <template v-slot:content>
          <template v-if="proceedOTP">
            <div class="otp-con">
              <one-time-password :email="email"></one-time-password>
            </div>
          </template>
          <template v-else>
            <login-email
              @proceed-otp="handleProceedOTP"
              @proceed-register="handleProceedRegister"
              @toggle-loading="toggleLoading"
            ></login-email>
            <!-- <div class="body-footnote">
              <div class="inner">
                <img src="@/assets/tpbf/SEAL-01.png" width="50" height="50" alt="The Philippines By Foot" />
                <div class="copyright">
                  © Copyright {{ thisYear }}, The Philippines By Foot. All rights reserved.
                </div>
                <div class="links">
                  <router-link to="/terms-of-use">Terms of Use</router-link>
                  <router-link to="/privacy-policy">Privacy Policy</router-link>
                </div>
              </div>
            </div> -->
          </template>
        </template>
      </landing-layout>
    </template>
  </layout-variant-two>
</template>
<script>
import LandingLayout from "@/components/layout/LandingLayout.vue";
import LayoutVariantTwo from "@/components/layout/LayoutVariantTwo.vue";
import OneTimePassword from "@/presentation/components/OneTimePassword.vue";
import utility from "@/presentation/mixins/utility.js";
import LoginEmail from "./components/LoginEmail.vue";
export default {
  name: "LoginPage",
  mixins: [utility],
  components: {
    OneTimePassword,
    LoginEmail,
    LayoutVariantTwo,
    LandingLayout,
  },
  props: {
    passedEmail: {
      type: String,
      default: "",
    },
    inModal: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      email: "",
      proceedOTP: false,
      isError: false,
      showBack: false,
      loading: false,
      thisYear: null,
      inited: false,
    };
  },
  methods: {
    toggleLoading(val) {
      this.loading = val == true;
    },
    async handleProceedOTP(email) {
      this.proceedOTP = true;
      this.email = email;
    },
    async handleProceedRegister(email) {
      let params = { passedEmail: email };
      if (this.$route.query.redirect)
        params.redirect = this.$route.query.redirect;
      this.goToWithParams("RegisterPage", params);
    },
  },
  async created() {
    this.showBack = this.$route.query.redirect != null;
    const date = new Date();
    this.thisYear = date.getFullYear();
    this.inited = false;
    await this.refreshMainData(true);
    this.inited = true;
  },
  mounted() {
    if (this.passedEmail) {
      this.handleProceedOTP(this.passedEmail);
    }
  },
};
</script>

<style lang="scss" scoped>
.otp-con {
  padding: 0 24px;
  width: 100%;
}

.header-con {
  justify-content: flex-start;
  gap: 16px;
  color: $secondary-color-80;

  &.float {
    background: rgba($color: $white, $alpha: 0.7);
    padding: 8px !important;
    border-radius: 50%;
    position: absolute;
    top: 16px;
    left: 16px;
    right: 0;
    z-index: 2;
    width: fit-content;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  }

  * {
    cursor: pointer;
  }
}

.body-footnote {
  .copyright {
    font-size: 14px;
    line-height: 20px;
  }

  .inner {
    margin: 0 auto;

    .links {
      margin-top: 10px;

      a {
        color: $banner-color;
        font-size: 13px;
        margin: 0 7px;
        text-decoration: underline;
      }
    }

    img {
      margin: 0 auto;
      width: 50px;
      height: 50px;
      object-fit: contain;
      display: block;
      margin-bottom: 10px;
    }
  }

  background: $secondary-color-20;
  margin-top: auto;
  padding: 16px;
  color: $banner-color;
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font-size: 0.85em;

  &.invisible {
    display: none !important;
  }

  .footnote-tnc {
    display: flex;
    gap: 48px;
    align-items: center;

    .tnc-item {
      font-weight: bold;
      cursor: pointer;
      color: $banner-color;
    }
  }
}
</style>
